import $ from 'jquery';
window.jQuery = $;
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";


//import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { SplitText } from "gsap/SplitText";
import { Flip } from "gsap/Flip";

import { select2 } from 'select2';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText, ScrollSmoother, Flip);

import barba from '@barba/core';

import Swiper from 'swiper/swiper-bundle';
//import { Navigation, Pagination } from 'swiper';
/* import createShadow from 'swiper/shared/create-shadow.js';
import effectInit from 'swiper/shared/effect-init.js';
import effectTarget from 'swiper/shared/effect-target.js';
import { getSlideTransformEl } from 'swiper/shared/utils.js'; */

import Cookies from 'js-cookie';
import { Fancybox } from "@fancyapps/ui";



const tasks = {
    taskList: [],
    running: false,
    yieldToMain: function () {
        return new Promise(resolve => {
            setTimeout(resolve);
        });
    },
    add: function (task, delay = 0) {
        setTimeout(() => {
            if (typeof task === 'function') {
                this.taskList.push(task);
            } else if (Array.isArray(task)) {
                this.taskList = this.taskList.concat(task);
            }
            if (!this.running) {
                this.run();
            }
        }, delay);
    },
    run: async function () {
        this.running = true;
        while (this.taskList.length > 0) {
            await this.yieldToMain();
            let task = this.taskList.shift();
            task();
        }
        this.running = false;
    }
};

window.timelines_triggers = [];




const fp = {
    init: function(container = document){
        let obj = this;
        let $bg = $(container).find('.fp-bg');
        if($bg.length > 0){
            let height  = $bg.height();
            var callParallax = function callParallax(e) {
                parallaxIt(e, $bg);
            };

            var parallaxIt = function parallaxIt(e, target) {
                let y = (100 * e.pageY) / height;
                let pos = y;
                if(y < 0){
                    pos = 0;
                }
                if( y > 100){
                    pos = 100;
                }
                gsap.to(target, 1.5, {
                    transformOrigin: '50% 50%',
                    backgroundPosition: 'center '+pos+'%',
                    ease: "power1.out"
                    //ease: "none"
                });
            };

            $(document).mousemove(function (e) {
                window.requestAnimationFrame(callParallax.bind(null, e));
            });

        }
    }
}

const login = {
    init: function(container = document){
        let obj = this;
        let $bg = $(container).find('.login-bg');
        if($bg.length > 0){

            let width  = $bg.width();

            var callParallax = function callParallax(e) {
                parallaxIt(e, $bg.find('image'));
            };

            var parallaxIt = function parallaxIt(e, target) {
                console.log(e.pageX);
                let x = (100 * e.pageX) / width;
                let pos = x;
                if(x < 0){
                    pos = 0;
                }
                if( x > 100){
                    pos = 100;
                }
                gsap.to(target, 1.5, {
                    transformOrigin: '50% 50%',
                    x: pos+'% ',
                    ease: "power1.out"
                    //ease: "none"
                });
            };

            $(document).mousemove(function (e) {
                window.requestAnimationFrame(callParallax.bind(null, e));
            });

        }
    }
}
const splitTxt = {
    splitLines: null,
    splitWords: null,
    init : function(container = document){
        let obj = this;
        obj.splitLines = new SplitText('h1', { type: "lines" });
        obj.splitWords = new SplitText('.newsletter-inner h2', { type: "words" });
    },
    revert: function(){
        if(splitTxt.splitLines !== null ) {
            splitTxt.splitLines.revert();
        }
        if(splitTxt.splitWords !== null ) {
            splitTxt.splitWords.revert();
        }
        splitTxt.init();
    }
}
const forms = {

    floatClass : '.float-label',
    loginClass : '.login-form',
    ajaxClass: '.ajax-form',
    init : function(container = document){
        let obj = this;
        $(document).on('keyup', '.float-label input, .float-label textarea', function(e){
            let $this = $(this);
            if($this.val() !== ''){
                $this
                    .parent()
                    .addClass('float');
            }else{
                $this
                    .parent()
                    .removeClass('float');
            }
        });
        obj.ajaxInit();
        obj.ajaxLogin();
        var heightLimit = 144;
        var $textareas = $(document).find('textarea');

        $.each($textareas, function(){
            this.oninput = function() {
                this.style.height = "";
                this.style.height = this.scrollHeight + "px";
               // console.log(this.style.height);
            }
        })

    /*    $(document).on('oninput', 'textarea', function(e){
            this.style.height = "";
            this.style.height = Math.max(this.scrollHeight, heightLimit) + "px";
            console.log(this.style.height);
        })*/
    },
    ajaxInit: function(){
        let obj = this;
        $(document).on('submit', obj.ajaxClass, function(e){
            e.preventDefault();
            let $this = $(this);
            $this.find('input[name="csrf_token"]').val(crsf);
            let $formID = $this.data('id');
            $this
                .find('.has-error')
                .removeClass('has-error');
            $.ajax({
                url:$this.attr('action'),
                data: $this.serialize(),
                type: 'POST'
            }).done(function( data ) {
                let info = data;
                crsf = data.csrfHash;
                let $csrf = $(document).find('input[name="'+data.csrfName+'"]');
                $.each($csrf, function(){
                    $(this).val(data.csrfHash)
                })
                if(info.status === 0){
                    $.each(info.errors, function(){
                        let $input = $this.find('[id ^="field-"][id $="-'+this[1]+'"]');
                        if($input.length > 0){
                            $input
                                .parent()
                                .addClass('has-error')
                                .find('.input-field--error')
                                .html(this[0]);
                        }
                    });
                }else{

                    if($this.hasClass('reg-form')){

                        $this
                            .parent()
                            .parent()
                            .addClass('success')
                            .find('.form-msg')
                            .html(info.message)
                    }else{
                        let $parent = $this.parent();
                        $parent
                            .hide()
                            .prev()
                            .hide();

                        $parent
                            .next()
                            .show();

                        $parent
                            .parents('.contacts-form--content')
                            .addClass('success')
                            .find('.form-msg')
                            .html(info.message)
                            .show();
                    }
                }
            })
        })
    },
    ajaxLogin: function(){
        let obj = this;
        $(document).on('submit', obj.loginClass, function(e){
            e.preventDefault();
            let $this = $(this);
            $this.find('input[name="csrf_token"]').val(crsf);
            let $msg = $this.find('.default-form--error');
            $.ajax({
                url:$this.attr('action'),
                data: $this.serialize(),
                type: 'POST'
            }).done(function( data ) {
                let info = data;
                crsf = data.csrfHash;
                if(info.status === 0){
                    $msg.html('');
                    $this.addClass('has-error');
                    $.each(info.errors, function(){
                        $msg.append('<span>'+this+'</span>');
                    });
                }else{
                    location.reload();
                }
            })
        });
    },
    reset : function(){

        setTimeout(function(){
            let $cont =  $('#contacts-form');
            $cont
                .find(".contacts-form--left")
                .show();

            $cont
                .find(".contacts-form--right")
                .show();

            $cont
                .find('.form-msg')
                .hide();

            $cont
                .find('.success')
                .removeClass('success');

            $cont
                .find(".float")
                .removeClass('float');

            $cont
                .find('form')[0]
                .reset();
        },500)
    }

}
const gdpr = {
    init: function(){
        if(Cookies.get('cookie-accept') !== '1') {
            let $gdpr = $('.cookie-notice');

            setTimeout(function () {
                $gdpr.addClass('active');
            }, 700);

            let $cookieAccept = $('.accept-cookies');
            $cookieAccept.on('click', function(){
                $gdpr.removeClass('active');
                Cookies.set('cookie-accept', 1, { expires: 30 })
            });
        }
    }
}

const reveals = {
    init : function(container = document){
       let obj = this;
        introEdition.init(container);
 /*      obj.fb(container);
       obj.reveal(container);*/
    },
    fb: function(container = document){
        const $fb = $(container).find('.fp');
        if($fb.length > 0 ) {
            gsap.fromTo($fb, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                delay : 2
            })
        }
    },
    reveal : function(container = document){
        let $reveal = $(container).find('.js-reveal');
        $.each($reveal, function(){
            let $this = $(this);
            let $items = $this.find('.js-reveal-item');

            let tl = gsap.timeline({
                paused:true,
                stagger: 0.2
            });

            $.each($items, function(){
                let $item = $(this);
                tl.fromTo($item.children(),
                    { autoAlpha: 0, y: 25},
                    { autoAlpha: 1, y: 0, stagger: 0.2 }
                );
            });

            tl.play();
        });
    }
}

const introEdition = {
    header: function(){
        console.log("WIP - header function");
        return true;
        let $header = $('.header-inner');
        if($header.length > 0) {
            gsap.fromTo($header,
                {
                    autoAlpha: 0,
                    y: '15%'
                },
                {
                    autoAlpha: 1,
                    y: 0,
                    //  duration: 1.5,
                    duration: 1.5,
                    delay: 0.4,
                    ease: "power3.out",
                    onStart: function () {

                    },
                    onComplete: function () {
                    }
                }
            );
        }
    },
    init: function(container = document){
        if(!$(container).find('.gdpr').length > 0){
        //    let fb = gsap.matchMedia();
         //   fb.add("(min-width: 960px)",() => {
                let $items = $(container).find('.js-reveal--items');
                let first = true;
                $.each($items, function(){
                    let $item = $(this);
                    let tl = gsap.timeline({paused: true});
                    $.each($item.find('.js-reveal--item'), function(index){
                        let $this = $(this);
                        let delay = 0;
                        $.each($this.children(), function(index){
                            if(!first){
                                delay = '-=0.3';
                            }
                            first = false;
                            if($(this).hasClass('cta') && false){
                                let $cta = $(this);
                                tl
                                    .fromTo($cta.find('svg'), {
                                        autoAlpha: 0,
                                    }, {
                                        autoAlpha: 1,
                                        duration: 0.3,
                                        ease: 'none'
                                    },delay)
                                    .fromTo($cta.find('span'), {
                                        autoAlpha: 0,
                                        x: -25
                                    }, {
                                        x: 0,
                                        autoAlpha: 1,
                                        ease: 'none',
                                        duration: 0.3,
                                        onStart: function () {
                                            gsap.set($this, {autoAlpha: 1});
                                        }
                                    },delay)
                            }else {
                                tl.fromTo(this, {
                                    autoAlpha: 0,
                                    y: 15
                                }, {
                                    autoAlpha: 1,
                                    y: 0,
                                    ease: 'none',
                                    duration:0.45,
                                    onStart: function () {
                                        gsap.set($this, {autoAlpha: 1});
                                    }
                                },delay);
                            }
                        });
                    });
                    tl.play();
                });
         //   });
            return '';
        }
        if($(container).find('.gdpr').length > 0 ){

            let $header = $(container).find('.gdpr-content--back, .gdpr-content--logo, h1')
            $.each($header, function(){
                let $this = $(this);
                let tl = gsap.timeline({ paused : true});
                tl.fromTo($this, {
                    y: 25,
                    autoAlpha: 0
                },{
                    y: 0,
                    autoAlpha: 1
                });
                ScrollTrigger.create({
                    trigger: $this,
                    start: "top 90%",
                  //  markers: true,
                    onEnter: function() {
                        tl.play();
                    },
                    onEnterBack: function(){
                    },
                    onLeave: function(){
                    },
                    onLeaveBack: function(){
                    }
                });
            });

            let $items = $(container).find('.gdpr-content--page');

            $.each($items.children(), function(){
                let $this = $(this);
                let tl = gsap.timeline({ paused : true});
                tl.fromTo($this, {
                    y: 25,
                    autoAlpha: 0
                },{
                    y: 0,
                    autoAlpha: 1
                });
                ScrollTrigger.create({
                    trigger: $this,
                    start: "top 90%",
                  //  markers: true,
                    onEnter: function() {
                        tl.play();
                    },
                    onEnterBack: function(){

                    },
                    onLeave: function(){

                    },
                    onLeaveBack: function(){

                    }
                });
            });

            gsap.set($items,{ autoAlpha: 1});
        }
    }
}

const cta = {
    set: function(container = document){
        let $items = $('.cta-circle');
        $.each($items, function() {
            let $item = $(this);
            gsap.set($item , {autoAlpha: 0});
        });
    },
    init: function(container = document){
        let $items = $('.cta-circle');

        $.each($items, function(){
            let $item = $(this);
            let tl = gsap.timeline({paused:true});
            tl
                .fromTo($item.find('svg'),{
                    autoAlpha: 0
                }, {
                    autoAlpha: 1,
                    duration: 1.2
                })
                .fromTo($item.find('span'),{
                    autoAlpha: 0,
                    x: -25
                }, {
                    autoAlpha: 1,
                    x : 0
                },'-=0.2');

            gsap.set($item,{
                autoAlpha: 1
            });

            ScrollTrigger.create({
                trigger: $item[0],
                start: "top 75%",
                onEnter: function(){
                    tl.play();
                }
            });
        });
    }
}

const headerAnim = {
    init: async function(container = document){
        //container.querySelectorAll('.h1-anim h1').forEach((el) => {
        for (const el of container.querySelectorAll('.h1-anim h1')) {
            // split el into lines and characters, lines having class of 'h1-line' and characters 'h1-char'. Wrap each character in a span.
            let split = new SplitText(el, {type: 'lines, chars, words', wordsClass: 'h1-word', linesClass: 'h1-line', charsClass: 'h1-char'});
            // gsap timeline for the animation with scrollTrigger to trigger it when the el is in view
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 75%',
                    end: 'bottom 25%',
                    scrub: false,
                    once: true,
                    // markers: true,
                },
                onComplete: function(){
                    // remove the lines and chars classes from the el
                    //split.revert();
                    let st = ScrollTrigger.create({
                        trigger: el,
                        start: 'bottom top',
                        end: 'bottom -100%',
                        once: true,
                        onEnter: function(self){
                            split ? split.revert() : null;
                        },
                    });

                    // add one time resize event that reverts the splitText if it's still present
                    window.addEventListener('resize', function(){
                        split ? split.revert() : null;
                        st ? st?.kill?.() : null;
                    }, {once: true});

                }
            });
            tl.from(el, {scale: 1.2, x: -15, duration: 1.5, ease: 'power2.out', clearProps: 'all'})
              .from(split.chars, {opacity: 0, x: 15, y: 33, scale:0.9, rotate: 12, stagger: 0.015, duration: 1.5, ease: 'power4.out'}, 0);

            gsap.set(el, {opacity: 1});
            window.timelines_triggers.push(tl);
            await tasks.yieldToMain();
        }

        
        for (const el of container.querySelectorAll('.h2-anim h2')) {
        //container.querySelectorAll('.h2-anim h2').forEach((el) => {
            // split el into lines and characters, lines having class of 'h1-line' and characters 'h1-char'. Wrap each character in a span.
            let split = new SplitText(el, {type: 'lines, chars, words', wordsClass:'h2-word', linesClass: 'h2-line', charsClass: 'h2-char', lineThreshold: 0.2});
            // gsap timeline for the animation with scrollTrigger to trigger it when the el is in view
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 75%',
                    end: 'bottom 25%',
                    scrub: false,
                    once: true,
                    // markers: true,
                },
                onComplete: function(){
                    // remove the lines and chars classes from the el
                    //split.revert();
                    let st = ScrollTrigger.create({
                        trigger: el,
                        start: 'bottom top',
                        end: 'bottom -100%',
                        once: true,
                        onEnter: function(self){
                            split ? split.revert() : null;
                        },
                    });

                    // add one time resize event that reverts the splitText if it's still present
                    window.addEventListener('resize', function(){
                        split ? split.revert() : null;
                        st ? st?.kill?.() : null;
                    }, {once: true});

                }
            });
            tl.from(el, {scale: 1.2, x: -15, duration: 1.5, ease: 'power2.out'})
              .from(split.chars, {opacity: 0, x: 15, y: 33, scale:0.9, rotate: 12, stagger: 0.015, duration: 1.5, ease: 'power4.out'}, 0);

            gsap.set(el, {opacity: 1});
            window.timelines_triggers.push(tl);
            await tasks.yieldToMain();
        }

        let footerLogo = $('#svg_logoftr');
        let letters = footerLogo.find('path');
        if(footerLogo.length > 0 && letters.length > 0) {
            gsap.killTweensOf([letters, footerLogo]);
            gsap.set([letters, footerLogo], {clearProps: 'all'});
            let tl_ftr = gsap.timeline({
                scrollTrigger: {
                    trigger: footerLogo[0],
                    start: 'top 75%',
                    end: 'bottom 25%',
                    scrub: false,
                    once: true,
                    //markers: true,
                },
            });
            tl_ftr.from(footerLogo, {scale: 1.2, x: -15, duration: 1.5, ease: 'power2.out'})
                .from(letters, {
                    opacity: 0,
                    x: 15,
                    y: 33,
                    scale: 0.9,
                    rotate: 12,
                    stagger: 0.03,
                    duration: 1.5,
                    ease: 'power4.out'
                }, 0);
            window.timelines_triggers.push(tl_ftr);
        }
    },
    prep: function(container = document){
        container.querySelectorAll('.h1-anim h1, .h2-anim h2').forEach((el) => {
            // change el opacity to 0
            gsap.set(el, {opacity: 0});
        });
    },
    deinit: function(container = document){

    }
};

const fadeUpAnim = {
    init: function(container = document){
        container.querySelectorAll('.fade-up').forEach((el) => {
            // create scrollTrigger for each el, that will add "now" class to the el when it's in view
            ScrollTrigger.create({
                trigger: el,
                start: 'top 75%',
                end: 'bottom 25%',
                scrub: false,
                once: true,
                // markers: true,
                onEnter: function(self){
                    el.classList.add('now');
                    /* setTimeout(function(){
                        el.classList.remove('fade-up');
                    }, 1000); */
                }
            });
        });

        // create scrollTrigger batch for ".fade-up-stagger" elements, that will add "now" class to the el when it's in view staggered bu 0.1s
        let els = container.querySelectorAll('.fade-up-stagger');
        ScrollTrigger.batch(els, {
            start: 'top 75%',
            end: 'bottom 25%',
            scrub: false,
            once: true,
         //   markers: true,
            onEnter: function(batch){
                batch.forEach((el, i) => {
                    setTimeout(function(){
                        el.classList.add('now');
                        /* setTimeout(function(){
                            el.classList.remove('fade-up-stagger');
                        }, 1000); */
                    }, i * 100);
                });
            }
        });

        let els2 = container.querySelectorAll('.fade-up-stagger2');
        ScrollTrigger.batch(els2, {
            start: 'top 85%',
            end: 'bottom 25%',
            scrub: false,
            once: true,
           // markers: true,
            onEnter: function(batch){
                batch.forEach((el, i) => {
                    setTimeout(function(){
                        el.classList.add('now');
                        /* setTimeout(function(){
                            el.classList.remove('fade-up-stagger');
                        }, 1000); */
                    }, i * 100);
                });
            }
        });
        
    },
    deinit: function(container = document){

    }
};

const zoomOutAnim = {
    init: function(container = document){
        container.querySelectorAll('.img-zoom-out').forEach((el) => {
            // create scrollTrigger for each el, that will add "now" class to the el when it's in view
            ScrollTrigger.create({
                trigger: el,
                start: 'top 60%',
                end: 'bottom 110%',
                scrub: false,
                once: true,
                // markers: true,
                onEnter: function(self){
                    el.classList.add('now');
                    setTimeout(function(){
                        el.classList.remove('img-zoom-out','now');
                    }, 1000);
                }
            });
        });
    },
    deinit: function(container = document){

    }
};

const filterListAnim = {
    init: function(container = document){
        let els = container.querySelectorAll('.filter-list--results tr');
        /* els.forEach((el) => {
            // create scrollTrigger for each el, that will add "anim" class to the el when it's in view
            ScrollTrigger.create({
                trigger: el,
                start: 'bottom bottom',
                end: 'bottom 120%',
                scrub: false,
                once: true,
                // markers: true,
                onEnter: function(self){
                    el.classList.add('anim');
                }
            });
        }); */
        if(els.length){
            ScrollTrigger.batch(els, {
                batchMax: 15,
                start: 'bottom bottom',
                end: 'bottom 120%',
                scrub: false,
                once: true,
                // markers: true,
                onEnter: function(batch){
                    batch.forEach((el, i) => {
                        setTimeout(function(){
                            el.classList.add('anim');
                        }, i * 50);
                    });
                }
            });
            setTimeout(function(){
                ScrollTrigger.sort();
                ScrollTrigger.refresh();
            },50);
        }
    },
    deinit: function(container = document){

    }
};
/* function EffectCoverflowCustom(_ref) {
    let {
        swiper,
        extendParams,
        on
    } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
        },
    });
    const setTranslate = () => {
        const {
            width: swiperWidth,
            height: swiperHeight,
            slides,
            slidesSizesGrid,
        } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal
            ? -transform + swiperWidth / 2
            : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for (let i = 0, length = slides.length; i < length; i += 1) {
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier =
                typeof params.modifier === "function"
                    ? params.modifier(centerOffset)
                    : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) {
                stretch = (parseFloat(params.stretch) / 100) * slideSize;
            }
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = effectTarget(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
              // Set shadows
              let shadowBeforeEl = isHorizontal
                ? slideEl.querySelector(".swiper-slide-shadow-left")
                : slideEl.querySelector(".swiper-slide-shadow-top");
              let shadowAfterEl = isHorizontal
                ? slideEl.querySelector(".swiper-slide-shadow-right")
                : slideEl.querySelector(".swiper-slide-shadow-bottom");
              if (!shadowBeforeEl) {
                shadowBeforeEl = createShadow(
                  "coverflow",
                  slideEl,
                  isHorizontal ? "left" : "top"
                );
              }
              if (!shadowAfterEl) {
                shadowAfterEl = createShadow(
                  "coverflow",
                  slideEl,
                  isHorizontal ? "right" : "bottom"
                );
              }
              if (shadowBeforeEl)
                shadowBeforeEl.style.opacity =
                  offsetMultiplier > 0 ? offsetMultiplier : 0;
              if (shadowAfterEl)
                shadowAfterEl.style.opacity =
                  -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration) => {
        const transformElements = swiper.slides.map((slideEl) =>
            getSlideTransformEl(slideEl)
        );
        transformElements.forEach((el) => {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            ).forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    effectInit({
        effect: "coverflow",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => true,
        overwriteParams: () => ({
            watchSlidesProgress: true,
        }),
    });
} */

const carousels = {
    spaSwiper: null,
    galleriesImgs : null,
    init: function (container = document) {
        let $swiperContainer = $(container).find('.about3-gallery');
        if($swiperContainer.length > 0) {
            var swiper = new Swiper(".about3-gallery .swiper-gallery", {
                // modules: [Navigation, Pagination, EffectCoverflowCustom],
                // loop: true,
                // slidesPerView: 2, // or 'auto'
                //slidesPerView: "auto", // or 'auto'
                // spaceBetween: 50,
                // centeredSlides: true,
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                effect: "coverflow", // 'cube', 'fade', 'coverflow',
                coverflowEffect: {
                    rotate: 0, // Slide rotate in degrees
                    scale: 0.9, // Slide zoom in %
                    stretch: -30, // Stretch space between slides (in px)
                    depth: 100, // Depth offset in px (slides translate in Z axis)
                    modifier: 1, // Effect multipler
                    slideShadows: true, // Enables slides shadows
                },
                grabCursor: true,
                //parallax: true,
                //spaceBetween: 0,
                slidesPerView: 2,
                centeredSlides: true,
                roundLengths: true,
                loop: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        coverflowEffect: {
                            stretch: -20, // Stretch space between slides (in px)
                        }
                    },
                    640: {
                        slidesPerView: 2,
                        coverflowEffect: {
                            stretch: -30, // Stretch space between slides (in px)
                        }
                    }
                }
            });
        }
    },
    mobileSwiper: null,
    spa: function (container = document) {
        let obj = this;

        if ($(document).width() < 641) {
            obj.mobileSpa(container);
        }

        $(window).resize(function(){
            if ($(document).width() < 641) {
                if(obj.mobileSwiper === null) {
                    obj.mobileSpa(container);
                }
            }else{
                if(obj.mobileSwiper !== null){
                    console.log("DERPPP");
                    obj.mobileSwiper.destroy();
                    obj.mobileSwiper = null;
                }
            }
        });
    },
    mobileSpa: function(container = document){
        let obj = this;
        let $cont = $(container).find('.zones-popup');
        if($cont.length > 0) {
            obj.mobileSwiper = new Swiper(".zones-types", {
                    pagination: {
                        el: ".zones-types--pagination",
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: ".zones-types--next",
                        prevEl: ".zones-types--prev",
                    },
                    effect: "coverflow", // 'cube', 'fade', 'coverflow',
                    coverflowEffect: {
                        rotate: 0, // Slide rotate in degrees
                        scale: 0.9, // Slide zoom in %
                        stretch: -30, // Stretch space between slides (in px)
                        depth: 100, // Depth offset in px (slides translate in Z axis)
                        modifier: 1, // Effect multipler
                        slideShadows: true, // Enables slides shadows
                    },
                    grabCursor: true,
                    parallax: true,
                    spaceBetween: 0,
                    slidesPerView: "auto",
                    centeredSlides: true,
                    roundLengths: true,
                    loop: true,
                    //  slideClass: '.zones-block'
                });
        }
    },
    galleries : function(container = document){
        let obj = this;
        let $popup = $(document).find('.galleries-carousel');
        let $gallery = $(document).find('.galleries-carousel--swiper');
        let $close = $(document).find('.zones-back');
        let $title = $(document).find('.galleries-carousel--title');
        let $btns = $(document).find('.galleries-nav--list .open-gallery');

        if($btns.length === 0){
            return 0;
        }

        obj.getGalleries();

        let swiper ;

        $btns.on('click', function(e){
            let $this = $(this);
            if(typeof $this.data('href') != 'undefined'){
                window.open($this.data('href'), '_blank');
                return false;
            }

    /*        $btns.removeClass('active');
            $this.addClass('active');

            if(typeof $this.data('href') != 'undefined'){
                window.open($this.data('href'), '_blank');
                return false;
            }

            let target = $this.data('target');
            let $swiperInner = $gallery.find('.swiper-wrapper');
            $swiperInner.html('');

            let title = '<h2>'+obj.galleriesImgs[target].title+'</h2>';
            if(obj.galleriesImgs[target].full_title.length > 0){
                title = obj.galleriesImgs[target].full_title
            }

            $title.html(title);
            $.each(obj.galleriesImgs[target].photos, function(){
                let img = this;
                $swiperInner.append(
                    '<div class="swiper-slide">\n' +
                        '<a href="'+base_url+'media/galleries/'+img.filename+'" data-fancybox="gallery">\n' +
                            '<img src="'+base_url+'media/galleries/view/'+img.filename+'">\n' +
                        '</a>\n' +
                    '</div>'
                );
            })
            swiper = new Swiper(".swiper-gallery", {
                
                pagination: {
                    el: ".galleries-carousel--pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".galleries-button-next",
                    prevEl: ".galleries-button-prev",
                },
                effect: "coverflow", // 'cube', 'fade', 'coverflow',
                coverflowEffect: {
                    rotate: 0, // Slide rotate in degrees
                    scale: 0.9, // Slide zoom in %
                    stretch: -30, // Stretch space between slides (in px)
                    depth: 100, // Depth offset in px (slides translate in Z axis)
                    modifier: 1, // Effect multipler
                    slideShadows: true, // Enables slides shadows
                },
                grabCursor: true,
                parallax: true,
                spaceBetween: 0,
                slidesPerView: "auto",
                centeredSlides: true,
                roundLengths: true,
                loop: true,
                breakpoints: {
                    320: {
                        coverflowEffect: {
                            stretch: -10, // Stretch space between slides (in px)
                        }
                    },
                    640: {
                        coverflowEffect: {
                            stretch: -30, // Stretch space between slides (in px)
                        }
                    }
                }
            });
            $popup.addClass('active');
            $('body').addClass('gallery-open');*/
        });

        $close.on('click', function (){
            $('body').removeClass('gallery-open');
            $popup.removeClass('active');
            setTimeout(function(){
                swiper.destroy();
            },600)
        });
        $(document).keyup(function(e) {
            if (e.key === "Escape") { // escape key maps to keycode `27`
                // <DO YOUR WORK HERE>
                if($(document).find('.fancybox__container').length === 0) {
                    $('body').removeClass('gallery-open');
                    $popup.removeClass('active');
                    setTimeout(function () {
                        swiper.destroy();
                    }, 600)
                }
            }
        });

    },

    getGalleries: function(){
        let obj = this;
        if(obj.galleriesImgs == null){
            console.log('GET IMAGES');
            $.ajax({
                url: gallery_url,
                data: {
                    action : 'getGalleries',
                    csrf_token : crsf
                },
                type: 'POST'
            }).done(function( data ) {
                crsf = data.csrfHash;
                obj.galleriesImgs = data.gallery;
            })
        }
    }
};

const list = {
    listItems: null,
    init: function(container = document){
        let $nav = $(container).find('.about5-nav');
        if($nav.length === 0) { return false ;}
        let $list = $nav.find('.about5-nav--list');
        let $cont = $(container).find('.about5-cont');
        let $btns = $list.find('button');
        let $petal = $nav.find('.about5-nav--petal');
        let $titles = $cont.find('.about5-titles h3');
        let $txt = $cont.find('.about5-txt');
        let $imgs = $(container).find('.about5-imgs img');
        let $about5_animating = false;

        if($nav.length > 0) {
            let petalTo = gsap.quickTo($petal, "y",{duration: 0.3, ease: 'power2.out'});
            $list.on('mouseout', function (e) {
                let $this = $(this);
                let $active = $this.find('.active');
                let height = $active.outerHeight();
                let y = $active.data('target') * height;
                petalTo(y);
            });
            $btns.on('mouseenter', function (e) {
                let $this = $(this);
                let height = $this.outerHeight();
                let y = $this.data('target') * height;
                petalTo(y);

            }).on('click', function () {
                /* if ($about5_animating) {
                    return false;
                } */
                $about5_animating = true;
                setTimeout(function () {
                    $about5_animating = false;
                }, 800);
                let $this = $(this);
                let id = $this.data('target');

                if($this.hasClass('active')){ return false;}

                $btns.removeClass('active');
                $this.addClass('active');

                /* $.each($imgs, function(){
                    let $img = $(this);
                    if($img.data('key') === id){
                        gsap.set($img,{zIndex: 22,scale:1.3});
                        gsap.fromTo($img, {opacity: 0, scale:1.15},{opacity:1, scale:1, rotate:0.001, duration:1, ease:"power4.out", onComplete: function(){
                            $imgs.removeClass('active');
                            $img.addClass('active');
                            $img.css({"opacity": "", "z-index": ""});
                        }})
                    }
                }) */
                // refactor above loop to directly use element with data-key=id
                let $active = $imgs.filter('.active');
                let $img = $imgs.filter(`[data-key=${id}]`);

                $imgs.removeClass('active').css({"opacity": "", "z-index": ""});
                $img.addClass('active');

                if($active.length){
                    gsap.killTweensOf($imgs);
                    //gsap.killTweensOf($txt);
                    //gsap.killTweensOf($txt.children());
                    //gsap.killTweensOf($titles);
                    //gsap.set([$imgs,$txt,$titles,$txt.children()],{clearProps: "all"});
                    gsap.set([$imgs],{clearProps: "all"});
                    $active.css("z-index", "20");
                }

                gsap.set($img,{opacity: 0, zIndex: 22,scale:1.3});
                gsap.fromTo($img, {opacity: 0, scale:1.15},{opacity:1, scale:1, rotate:0.001, duration:1.5, ease:"power4.out", onComplete: function(){
                    $img.css({"opacity": ""});
                }});

                gsap.set($txt, {
                    height: $txt.outerHeight()
                });

                gsap.to($titles,{
                    duration:0.1,
                    opacity: 0,
                    x: '-2.5%',
                });

                gsap.to($txt.children(), {
                    opacity: 0,
                    duration:0.1,
                    x: '-2.5%',
                    onComplete: function(){
                        $titles.html(listItems[id]['title']).css({opacity:0});
                        $txt.html(listItems[id]['descr']).css({opacity:0}).children().css({opacity:0});
                        let height = 0;
                        $.each($txt.children(), function () {
                            height += $(this).outerHeight();
                        })
                        gsap.to($txt, {
                            height: height,
                            duration:0.3,
                            onComplete: function(){
                                $txt.css({opacity: 1});
                                gsap.fromTo($titles,{
                                    opacity:0,
                                    x: '5%'
                                }, {
                                    opacity: 1,
                                    x: 0,
                                    duration:0.3,
                                });
                                gsap.fromTo($txt.children(),{
                                    opacity:0,
                                    x: '5%'
                                }, {
                                    opacity: 1,
                                    x: 0,
                                    delay:0.1,
                                    duration:0.3
                                });
                            }
                        });
                    }
                });

                if($(document).width() < 1024){
                    scroller.scrollTo('.about5' ,true);
                    //scroller.scrollTo(($(container).find('.about5-left').offset().top - $('.header-mobile').outerHeight()) ,true);
                }

            });

           /* ScrollTrigger.create({
                trigger: $(container).find('.about5-left'),
                start: 'top 60%',
                end: 'bottom 110%',
                scrub: false,
                once: true,
                // markers: true,
                onEnter: function(self){
                    $(container)
                        .find('.about5-nav--list button')
                        .first()
                        .trigger('click');

                    setTimeout(function(){
                        $(container)
                            .find('.about5-nav')
                            .removeClass('hidden');
                    },1300);
                }
            });
*/
        }
    },

    apartment: function(container = document){
        // im to lazy to correct init ;D
        let $nav = $(container).find('.decor-nav');
        if($nav.length === 0) { return false ;}
        if(listDecor == null){ return false;}
        let $list = $nav.find('.decor-nav--list');
        let $btns = $list.find('button');
        let $petal = $nav.find('.decor-nav--petal');
        let $txt = $(container).find('.decor-text');
        let $gallery = $(container).find('.decor-photos');
        let $galleryTrigger = $(container).find('.decor-gallery');

        let $img = $(container).find('#pattern image');

        let photos = '';
        $.each(listDecor[0]['photos'], function(){
            photos +=  '<a href="'+base_url+'media/galleries/'+this.filename+'" data-fancybox="gallery"></a>\n'
        })
        $gallery.html(photos);

        if($nav.length > 0) {
            let petalTo = gsap.quickTo($petal, "y",{duration: 0.3, ease: 'power2.out'});
            $list.on('mouseout', function (e) {
                let $this = $(this);
                let $active = $this.find('.active');
                let height = $active.outerHeight();
                let y = $active.data('target') * height;
                let key = $active.data('target');
                $img.removeClass('active');
                $($img[key]).addClass('active');
                petalTo(y);
            });
            $btns.on('mouseenter', function (e) {
                let $this = $(this);
                let height = $this.outerHeight();
                let y = $this.data('target') * height;
                petalTo(y);

                let key = $this.data('target');

                $img.removeClass('active');

                $($img[key]).addClass('active');

            }).on('click', function () {
                let $this = $(this);
                let id = $this.data('target');

                gsap.to($galleryTrigger,{opacity:0, duration:0.4});

                $btns.removeClass('active');
                $this.addClass('active');

                gsap.set($txt, {
                    height: $txt.outerHeight()
                });

                let photos = '';
                $.each(listDecor[id]['photos'], function(){
                    photos +=  '<a href="'+base_url+'media/galleries/'+this.filename+'" data-fancybox="gallery"></a>\n'
                })
                $gallery.html(photos);
                gsap.to($txt.children(), {
                    opacity: 0,
                    duration:0.2,
                    x: '-5%',
                    onComplete: function(){
                        $txt.html(listDecor[id]['txt']).css({opacity:0});
                        let height = 0;
                        $.each($txt.children(), function () {
                            height += $(this).outerHeight();
                        })
                        gsap.to($txt, {
                            height: height,
                            duration:0.1,
                            onComplete: function(){
                                $txt.css({opacity: 1});
                                gsap.fromTo($txt.children(),{
                                    opacity:0,
                                    x: '5%'
                                }, {
                                    opacity: 1,
                                    x: 0,
                                    duration:0.3,
                                    onComplete: function(){
                                        gsap.fromTo($galleryTrigger,{
                                            opacity:0,
                                            x: '5%'
                                        }, {
                                            opacity: 1,
                                            x: 0,
                                        });
                                    }
                                });

                            }
                        });
                    }
                });

                if($(document).width() < 1024){
                    scroller.scrollTo('.decor' ,true);
                    //scroller.scrollTo(($(container).find('.about5-left').offset().top - $('.header-mobile').outerHeight()) ,true);
                }

            });

         //   $btns.first().trigger('click');
        }
    }
}



const apartments = {
    apartId: null,
    init: function (container = document) {
        let obj = this;
        obj.apartments(container);
        obj.apartment(container);
        obj.floor(container);
    },

    apartments: function (container) {
        let $cont = $(container).find('.apartments-viz');
        if ($cont.length > 0 ) {
            let href = $cont.data('href');
            let $tooltip = $(container).find('.apart-tooltip');
            let $tooltip_block = $tooltip.find('.apart-tooltip--block span');
            let $tooltip_floor = $tooltip.find('.apart-tooltip--floor span.aaa2');
            let $tooltip_floor1 = $tooltip.find('.apart-tooltip--floor span.aaa1');

            let $tooltip_available = $tooltip.find('.apart-tooltip--available span');
            let $tooltip_bot = $tooltip.find('.apart-tooltip--bot');
            let $tooltip_bot_content = $tooltip_bot.find('.apart-tooltip--available');
            let $tooltip_bot_data = $tooltip_bot.data();

            let $a = $cont.find('a, g');
            let tooltip_to_x = gsap.quickTo($tooltip, "x", { duration: 0.4, ease: 'power2.out' });
            let tooltip_to_y = gsap.quickTo($tooltip, "y", { duration: 0.4, ease: 'power2.out' });
            let tooltip_height = $tooltip.outerHeight();
            let mouse_to = 0;
            let mouse_moved = false;

            const appts = {};

            const r2El = $('#R2_1,#R2_2,#R2_3');

            $.each($a, function () {
                let $this = $(this);
                let id = $this.attr('id');
                if (typeof apartments_list[id] !== 'undefined' && apartments_list[id]['available'] === 0) {
                    $this.addClass('empty');
                    $tooltip.addClass('soldout');
                } else if (id.startsWith('R2')) {
                    $this.addClass('empty');
                    $this.addClass('not-allowed');
                    $tooltip.addClass('soldout');
                } else if (id === 'R3_1') {
                    $this.addClass('empty');
                    $this.addClass('not-allowed');
                    $tooltip.addClass('soldout');
                } else if (id === 'R1_1') {
                    $this.addClass('empty');
                    $this.addClass('not-allowed');
                    $tooltip.addClass('soldout');
                } else {
                    $this.addClass('available');
                }

                let info = id.split('_');
                $this.attr('href', href + '/' + info[0] + '_' + info[1] + '/').addClass('js-barba');
                if (typeof appts[info[0]] === 'undefined') appts[info[0]] = [];
                appts[info[0]].push($this);

                if (this.id.startsWith('R2')) {
                    this.classList.remove('js-barba');
                    this.addEventListener('click', (e) => e.preventDefault());
                }

                if (this.id === 'R1_1') {
                    this.classList.remove('js-barba');
                    this.addEventListener('click', (e) => e.preventDefault());
                }

                if (this.id === 'R3_1') {
                    this.classList.remove('js-barba');
                    this.addEventListener('click', (e) => e.preventDefault());
                }

                $this
                    .on('mouseenter', function () {
                        let bot_msg = '';
                        if (typeof apartments_list[id] !== 'undefined') {
                            $tooltip_floor1.show();
                            $tooltip_floor.show();
                            $tooltip.addClass('active');
                            $tooltip_block.html(apartments_list[id]['block']);

                            if (apartments_list[id]['floor'] === '3') {
                                $tooltip_floor.parent().hide().next().show();
                            } else {
                                $tooltip_floor.html(apartments_list[id]['floor']).parent().show().next().hide();
                            }
                            //$tooltip_available.html(apartments_list[id]['available']);

                            $tooltip.removeClass('available soldout hotel parking');

                            if ($this.hasClass('floor-hotel')) {
                                $tooltip.addClass('hotel')
                                bot_msg = $tooltip_bot_data.hotel;
                            } else if (apartments_list[id]['available'] === 0) {
                                $tooltip.addClass('soldout')
                                bot_msg = $tooltip_bot_data.sold;
                            } else {
                                $tooltip.addClass('available');
                                bot_msg = `${$tooltip_bot_data.free} ${apartments_list[id]['available']}`;
                            }
                            $tooltip_bot_content.text(bot_msg);

                        } else {
                            if (id.startsWith('R2')) {
                                r2El.addClass('hover');
                                $tooltip_floor1.hide();
                                $tooltip_floor.hide();
                                const floor = id.split('_')[1];


                                $tooltip.removeClass('available soldout hotel parking');
                                $tooltip.addClass('active');
                                $tooltip.addClass('hotel');
                                // $tooltip_floor.parent().hide();

                                //$tooltip_floor.html("NATIVO Hotel").parent().show().next().hide();
                                //data-hotel

                                $tooltip_block.html(`Rytmečio ${['', 'I', 'II', 'III'][id[1]]}`);
                                $tooltip_bot_content.text($tooltip_bot.data('hotel'));
                                return;
                            }


                            $tooltip_floor.html(1);
                            $tooltip
                                .removeClass('hotel parking soldout available')
                                .addClass('active parking');
                            $tooltip_bot_content.text($tooltip_bot_data.parking);
                            if ($this.attr('id') === 'R3_1') {
                                $tooltip_block.html('Rytmečio III');
                            } else {
                                $tooltip_block.html('Rytmečio I');
                            }
                        }
                        tooltip_height = $tooltip.outerHeight();
                    })
                    .on('mousemove', function (e) {
                        clearTimeout(mouse_to);
                        if (!mouse_moved) {
                            tooltip_to_x(e.pageX, e.pageX);
                            tooltip_to_y(e.pageY - tooltip_height, e.pageY - tooltip_height);
                        } else {
                            tooltip_to_x(e.pageX);
                            tooltip_to_y(e.pageY - tooltip_height);
                        }
                        mouse_moved = true;
                        mouse_to = setTimeout(function () {
                            mouse_moved = false;
                        }, 1000);
                    })
                    .on('mouseleave', function () {
                        r2El.removeClass('hover');
                        $tooltip.removeClass('active');
                    })
            });
            let tl = gsap.timeline({
                paused: true, onComplete: function () {
                    setTimeout(function () {
                        $cont.find('.animating').removeClass('animating');
                    }, 2000);
                }
            });
            let pos = 0
            let appts_order = ["R1", "R2", "SV", "R3", "P", "S"];
            appts_order.forEach(function (key) {
                if (typeof appts[key] !== 'undefined') {
                    tl.to(appts[key], {
                        duration: 0.2,
                        ease: 'none',
                        stagger: {
                            each: 0.11,
                            onStart: function () {
                                this._targets[0].classList.add('anim');
                            },
                            onComplete: function () {
                                this._targets[0].classList.remove('anim');
                            },
                        }
                    }, pos);
                    pos = pos + (key == "P" ? 0.05 : 0.13);
                }
            });
            setTimeout(function () {
                tl.play();
            }, 700);
        }
    },
    apartment: function (container) {
        let $cont = $(container).find('.apartment-cont');
        if ($cont.length > 0) {
            let id = $cont.data('id');

            apartments.apartId = id;
            let $nav = $cont.find('.apartment-nav button');
            let $plans = $cont.find('.apartment-plan');
            $.each($(container).find('.holder-plans div'), function () {
                $(this)
                    .find('#' + id)
                    .addClass('potato');
            })

            $cont.find('#' + id).addClass('current');
            $.each($plans, function () {
                $(this)
                    .find('#' + id)
                    .addClass('current');
                $(this).find('#' + id + '-1a').addClass('current');
            })

            $nav.on('click', function () {
                let $this = $(this);
                if (!$this.hasClass('active')) {
                    $nav.removeClass('active');
                    $this.addClass('active');

                    let target = $this.data('plan');
                    $plans.removeClass('active');
                    $.each($plans, function () {
                        if ($(this).data('plan') === target) {
                            $(this).addClass('active');
                        }
                    })
                }
            });
        }

        Fancybox.bind('[data-fancybox="plans"]', {
            Hash: false,
            hideScrollbar: false,
            on: {
                init: (fancybox, slide) => {

                },
                done: (fancybox, slide) => {
                    $(slide.$el).find('#' + apartments.apartId).addClass('current')
                    $(slide.$el).find('#' + apartments.apartId + '-1a').addClass('current')
                },
                'Carousel.change': (fancybox, slide) => {
                    $(slide.$el).find('#' + apartments.apartId + '-1a').addClass('current')
                    $(slide.$container).find('#' + apartments.apartId).addClass('current')
                }
            },
        });
    },
    floor: function (container) {
        let $plan = $(container).find('.floor-plan');
        if ($plan.length > 0) {
            let $floor_id = $plan.data('floor');
            let $floorNr = $plan.data('floornr');
            let $location = $(container).find('.floor-place');
            let href = $plan.data('href');
            let $tooltip = $plan.find('.floor-tooltip');
            let $title = $tooltip.find('.floor-tooltip--top');
            let $area = $tooltip.find('.floor-tooltip--area span');
            let $rooms = $tooltip.find('.floor-tooltip--rooms span');
            let $price = $tooltip.find('.floor-tooltip--price span');
            let $status = $tooltip.find('.floor-tooltip--status');

            if (typeof apartments_list['total_list'] !== 'undefined') {
                $.each(apartments_list['total_list'][$floorNr], function () {
                    let data = this;
                    let id = '#' + this['name'];
                    let $item = $plan.find('#' + this['name']);
                    $item.attr('href', href + '/' + this['floor_id'] + '/' + this['name']).addClass('js-barba');
                    if ($item.length > 0) {
                        let status = '';
                        switch (data['status']) {
                            case ('Laisvas'):
                                status = 'available';
                                break;
                            case ('Parduotas'):
                                $item.removeClass('js-barba');
                                status = 'sold';
                                break;
                            case ('Rezervuotas'):
                                status = 'reserved';
                                break;
                        }
                        $item.addClass(status);
                        $item.on('mouseenter', function () {

                            $location
                                .find('.current')
                                .removeClass('current');
                            $location
                                .find(id)
                                .addClass('current');
                            $tooltip
                                .removeClass('available')
                                .removeClass('reserved')
                                .removeClass('sold');
                            $tooltip.addClass(status);
                            $area.html(data.area);
                            $rooms.html(data.rooms);

                            if (typeof data.price !== 'undefined') {
                                $price
                                    .html(numberWithCommas(data.price))
                                    .parent()
                                    .show();
                                if (data['status'] !== 'Laisvas') {
                                    $price.parent().hide();
                                } else {
                                    $price.parent().show();
                                }
                            } else {
                                $price
                                    .parent()
                                    .hide();
                            }

                            /*  if(data['status'] !== 'Laisvas'){
                                  $price.hide();
                              }else{
                                  $price.show();
                              }
  
  */
                            $status.html(data.status);
                            $title.html(data.display_name);
                            $tooltip.addClass('active');

                        }).on('mouseleave', function () {
                            $tooltip.removeClass('active');
                            $location
                                .find('.current')
                                .removeClass('current');
                        }).on('mousemove', function (e) {
                            let left = e.pageX;
                            let top = e.pageY;

                            left -= $plan.position().left;
                            top -= $plan.position().top + $tooltip.outerHeight() + 20;

                            $tooltip.css({
                                left: left,
                                top: top
                            });

                        });
                    }
                });
            }

            let $tooltipPlace = $location.find('.floor-place--tooltip');
            if ($location.length > 0) {
                $location
                    .find('a')
                    .each(function () {
                        let $this = $(this);
                        $this.attr('href', href + '/' + $this.attr('id'));

                        $this.on('mousemove', function (e) {
                            let left = e.pageX;
                            let top = e.pageY;

                            left -= $location.position().left;
                            top -= $location.position().top + $tooltipPlace.outerHeight() + 10;

                            $tooltipPlace.css({
                                left: left,
                                top: top
                            });

                        }).on('mouseenter', function () {
                            $tooltipPlace.addClass('active');
                            let id = $this.attr('id').split('_');
                            $.each(houses, function () {

                                if (id[0] === 'R2') {
                                    $tooltipPlace.find('span.aaa1').show();
                                } else {
                                    $tooltipPlace.find('span.aaa1').hide();
                                }

                                if (id[0] === this.short_id) {
                                    $tooltipPlace.find('span.aaa2').html(this.title);
                                }
                            })


                        }).on('mouseleave', function () {
                            $tooltipPlace.removeClass('active');
                        })

                    })
            }

        }
    }
}
const filter = {
    init: function(container = document){

        let $cont = $(container).find('.filter');
        let $select = $(container).find('.filter-select');
        let $sort = $(container).find('[name="filter[sort]"]');
        let $filter = $(container).find('.filter-apartments');
        let $list =  $(container).find('.filter-list--results');

        if($filter.length === 0){ return false;}

        $select.on('click', function(){
            $(this).toggleClass('active');
        });

        $(document).on('click', function(e){
            if(!$(e.target).is($('.filter-select *'))){
                $select.removeClass('active');
            }
        });

        $filter.on('submit', function(e,ee){
            e.preventDefault();
         //   console.log("submiting ???")
            let $this = $(this);
            $this.find('input[name="csrf_token"]').val(crsf);
            $.ajax({
                beforeSend(){
                    if(typeof ee === 'undefined') {
                       // scroller.scrollTo($cont, false);
                       scroller.scrollTo("form.filter-apartments", true);
                    }
                },
                url:$this.attr('action'),
                data: $this.serialize(),
                type: 'POST'
            }).done(function( data ) {
                crsf = data.csrfHash;

                if(data.status === 1){
                    requestAnimationFrame(function(){
                        let $html = $.parseHTML(data.html);
                        $list.html('').append($html);
                        let $url = window.location.href.split('?');
                        barba.history.add($url[0]+'?'+data.args, 'barba', 'replace');
                        setTimeout(function(){
                            filterListAnim.init($list.get(0));
                        },0);
                    });
                    //ScrollTrigger.refresh();
                }
            })
        });

        $filter.find('input[type=radio]').click(function(){
            $filter.submit();
        })

        $filter.find("input[type=checkbox]").change(function(){
            $filter.submit();
            let $this = $(this);
            if($this.parents('.filter-options')){
                $this.next()
                let checked = false;
                $.each( $filter.find('.filter-options input[type=checkbox]'), function(){
                    if($(this).prop('checked')){
                        checked = true;
                    }
                });
                if(checked){
                    $filter.find('.filter-select').addClass('checked');
                }else{
                    $filter.find('.filter-select').removeClass('checked');
                }
            }
        });

        $filter.find('.filter-options input[type=checkbox]');

        let $sortLabels = $filter.find('th label');

        $sortLabels.on('click', function(e){
            let $this = $(this);
            let type = $this.data('sort');
            if($this.hasClass('active')){
                if($this.hasClass('switch')){
                    $this.removeClass('switch');
                    $sort.val(type+'_asc');
                }else{
                    $this.addClass('switch');
                    $sort.val(type+'_desc');
                }
            }else{
                $sortLabels.removeClass('active');
                $this.addClass('active').addClass('switch');
                $sort.val(type+'_desc');
            }
            $filter.submit();
        })

        $filter.on('click','button[type="reset"]', function(e){
            e.preventDefault();
            $filter[0].reset();

            $filter
                .find('.checked')
                .removeClass('checked');

           let $checks = $filter.find('[type="checkbox"]');
           $.each($checks, function(){
               $(this).attr('checked' , false);
           })

            $filter.submit();
        })

        let $controls = $(container).find('.filter-controls');
        let $toggle = $(container).find('.filter-slider button');

        $toggle.on('click', function(){
            $(this).toggleClass('active');
            $controls.slideToggle();
        });

       /* if($filter.length > 0){
            setTimeout(function(){
                $filter.trigger('submit',[{'page_load' : true}]);
            },400);
        }*/

        let url = window.location.href.split('?');
        if(typeof url[1] !== 'undefined'){
            scroller.scrollTo("form.filter-apartments", true);
        }

        let mm = gsap.matchMedia();

        mm.add("(min-width: 1023px)", () => {

            let st = ScrollTrigger.create({
                trigger: ".filter-inner",
                pin: ".filter-controls",
                start: "top top",
                endTrigger: '.contacts',
                end:"top bottom",
              // markers: true
            });

            return () => { // optional
                // custom cleanup code here (runs when it STOPS matching)
            };
        });


    }
}

const headers = {
    triggers  : null,
    menu      : null,
    mobile    : null,
    links     : null,
    first     : true,
    width     : 0,
    petalTop  : null,
    petalTop_x: null,

    top_timeout       : 0,   //timeout for top menu animation delays
    top_appear_timeout: 0,   //timeout for top menu animation appearing
    petalTop_timeout  : 0,   //timeout for petal animation

    init: function (container = document) {
        headers.menu = $(container).find(".header-menu");
        if (headers.menu.length == 0) return;

        headers.mobile   = $(container).find(".mobile-menu");
        headers.links    = $(document).find(".h-menu li");
        headers.burgers  = $(document).find(".hamburger");
        headers.width    = $(document).width();
        headers.petalTop = headers.menu.find(".petal");

        headers.petalTop_x = gsap.quickTo(headers.petalTop, "x", {
            duration: 0.6,
            ease    : "power2.out",
        });

        window.addEventListener("resize", function () {
            headers.width = $(document).width();
        });

        $.each(headers.burgers, function () {
            $(this).on("click", function () {
                headers.toggleMenu();
            });
        });

        headers.menu
            .find(".h-menu li:not(.logout)")
            .on("mouseenter", function (e) {
                clearTimeout(headers.petalTop_timeout);
                headers.resetTopPetal(false, $(this));
            })
            .on("mouseleave", function (e) {
                clearTimeout(headers.petalTop_timeout);
                headers.petalTop_timeout = setTimeout(function () {
                    headers.resetTopPetal();
                }, 100);
            });

        headers.links.on("click", function (e) {
            if ($(document.body).hasClass("trans-anim")) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            let $this = $(this);
            if ($this.find("a.scroll-to").length == 0) {
                headers.links.removeClass("h-is-active");
                $this.addClass("h-is-active");
            }
            if (headers.width <= 860 && !$this.data().hasOwnProperty("module")) {
                headers.toggleMenu("hide");
            } else {
                headers.resetTopPetal();
            }
        });

        $(document).scroll(headers.position);
    },
    resetTopPetal: function (instant = false, element = null, timeout = 0) {
        clearTimeout(headers.top_appear_timeout);
        const findActive = headers.menu.find(".h-menu li.h-is-active");
        if (findActive.length == 0 && element == null) {
            headers.petalTop.removeClass("visible");
            return;
        }

        headers.top_appear_timeout = setTimeout(function () {
            headers.petalTop.addClass("visible");
            const active = element == null ? findActive : element;
            const pos    = active.position().left + 10;
            if (instant) {
                headers.petalTop_x(pos, pos);
            } else {
                headers.petalTop_x(pos);
            }
        }, timeout);
    },
    toggleColor: function (container = document) {
        if (headers.menu.length > 0) {
            let offset     = headers.menu.position().top;
            let sections   = gsap.utils.toArray("[data-header]");
            let menuHeight = headers.menu.height();
            sections.forEach((block) => {
                ScrollTrigger.create({
                    trigger : block,
                    start   : "top " + (offset + menuHeight),
                    end     : "bottom " + offset,
                    onUpdate: (self) => {
                        let type = $(block).data("header");
                        switch (type) {
                            case "dark": 
                                headers.menu.addClass("dark");
                                break;
                            case "light": 
                                headers.menu.removeClass("dark");
                                break;
                        }
                    },
                });
            });
        }
    },
    toggleMenu: function (showHide = "", all = false) {
        const show = showHide === "show";
        const hide = showHide === "hide";
        clearTimeout(headers.top_timeout);
        clearTimeout(headers.top_appear_timeout);
        if (all && (show || hide)) {
            if (show) {
                if (headers.width > 860) {
                    headers.resetTopPetal(true, null, 700);
                }
                headers.burgers.addClass("is-active");
                headers.menu.addClass("active animating");
                headers.mobile.addClass("active animating");
            } else {
                if (headers.width > 860)
                    headers.petalTop_x(headers.petalTop.position().left + 150);
                headers.petalTop.removeClass("visible");
                headers.burgers.removeClass("is-active");
                headers.menu.removeClass("active");
                headers.mobile.removeClass("active");
            }
            return;
        }

        const header = headers.width > 860 ? headers.menu : headers.mobile;
        if(typeof headers.burgers !== 'undefined') {
            const burger = headers.burgers.eq(headers.width > 860 ? 0 : 1);
            const active = header.hasClass("active");
            if (hide || (active && !show)) {
                headers.petalTop_x(headers.petalTop.position().left + 150);
                headers.petalTop.removeClass("visible");
                burger.removeClass("is-active");
                header.removeClass("active");
            } else if (show || (!active && !hide)) {
                if (headers.width > 860) {
                    headers.resetTopPetal(true, null, !active ? 700 : 0);
                }
                burger.addClass("is-active");
                header.addClass("active animating");
            }
            headers.top_timeout = setTimeout(function () {
                headers.menu.removeClass("animating");
                headers.mobile.removeClass("animating");
            }, 700);
        }
    },
    current: function (module) {
        let $links = $(".header .h-menu li, .contacts-nav li");
        $links.removeClass("h-is-active");
        $.each($links, function () {
            let $this = $(this);
            if ($this.data("module") === module) {
                $this.addClass("h-is-active");
            }
        });
        if (headers.menu.find(".h-menu li.h-is-active").length === 0) {
            if(headers.petalTop !== null) {
                headers.petalTop.removeClass("visible");
            }
        } else if (headers.width > 860 && headers.menu.hasClass("active")) {
            headers.resetTopPetal();
        }
    },
    hide    : function () {
        $('.header').hide();
    },
    show    : function () {  $('.header').show(); },
    position: function (container = document) {
        let pos = $(window).scrollTop();
        if (headers.width > 860) {
            if (pos === 0) {
                headers.menu.addClass(`page-top`);
                headers.toggleMenu("show");
                headers.first = true;
            } else {
                if (headers.first) {
                    headers.toggleMenu("hide");
                }
                headers.menu.removeClass(`page-top`);
                headers.first = false;

                headers.petalTop.removeClass("visible");
                setTimeout(() => headers.petalTop.removeClass("visible"), 100);
            }
        }
    },
};


const favorite = {
    init : function(container = document){
        let $sticky = $('.favorites-sticky');
        let $nr = $('.favorites-sticky--amount, .header-mobile--favoritesAmount');
        $(document).on('click','.add-favorite', function(e){
            e.preventDefault();
            let $this = $(this);
            let id = $this.data('id');
            $.ajax({
                url: fav_url,
                data: {
                    id: id,
                    csrf_token : crsf
                },
                type: 'POST'
            }).done(function( data ) {
                crsf = data.csrfHash;
                if($this.hasClass("selected")){
                    let floater,startSVG,endSVG;
                    if($(document).width() > 860) {
                         floater = $(".favorites-sticky--float svg");
                         startSVG = $this.find("svg");
                         endSVG = $(".favorites-sticky--svg svg");
                    }else{
                         floater = $(".header-mobile--float svg");
                         startSVG = $this.find("svg");
                         endSVG = $(".header-mobile--favoritesSvg svg");
                    }
                    let vars1 = Flip.fit(floater.get(0), $this.get(0), {scale: true, getVars: true});
                    let vars2 = Flip.fit(floater.get(0), endSVG.get(0), {scale: true, getVars: true});
                    vars1.opacity = 1;
                    vars2.opacity = 0;
                    vars2.duration = 2;
                    vars2.ease = "expo.out";
                    vars2.overwrite = true;
                    gsap.fromTo(floater, vars1, vars2);
                }
                $nr.html(data.favs);
                if(data.favs === 0){
                    $sticky.removeClass('active');
                }else{
                    $sticky.addClass('active');
                }

                let favsVal = '';
                let $favInput = $(document).find('.form-hide input[name=favorites]');
                if(data.names.length > 0){
                    $.each(data.names, function(){
                        favsVal += ' '+this.display_name;
                    });
                }
                $favInput.val(favsVal);
            });
            $this.toggleClass('selected');
        })
    }
}
const galleries = {

    init: function(container = document){

        let obj = this;
        // Fancybox.bind('[data-fancybox^="gallery-"]', {
        //     Hash: false,
        //     caption: function (fancybox, carousel, slide) {
        //         console.log(slide);
        //         return (
        //             `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption
        //         );
        //     },
            

        // });


    /*    Fancybox.bind('[data-fancybox^="gallery-"]', {
            Hash: false,
            caption: function (fancybox, carousel, slide) {
                return (
                    `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption
                );
            },
            on: {
                initLayout: (fancybox)=> {
                    $(fancybox.$container)
                        .addClass('galleries-fancybox');
                },
                done: (fancybox, el) => {
                },
                shouldClose: (fancybox) => {
                  //  scroller.paused(false);
                },
                destroy: (fancybox) =>{

                },
                close: (fancybox) => {

                }
            },
            Toolbar: {
                display: [
                    {
                        id: "counter",
                        position: "center"
                    },
                    "close"],
            }
        });
*/
        carousels.galleries(container);

    }
}
const spa = {
    spas: null,
    init: function (container = document){
        let obj = this;

        if(obj.spas === null){
            obj.spas = spas;
        }

        let $svg = $(container).find('.about4-svg svg');

        if($svg.length > 0){
            let $links = $svg.find('a');


            let $tooltip = $(container).find('.about4-svg--tooltip');
            let $title = $tooltip.find('.about4-svg--tooltipHeader');
            let $img = $tooltip.find('.about4-svg--tooltipImg img');
            let imgUrl = $svg.parent().data('url');

            let tl = gsap.timeline({paused: true});
            let pos = 0

            $.each($links , function(){
                let $this = $(this);
                tl.to($this,{
                    duration:0.8,
                    ease:'none',
                    marker: true,
                    delay: 0.7,
                    onStart: function(){
                        $this.addClass('anim');
                    },
                    onComplete: function(){
                        $this.removeClass('anim');
                    }
                },pos);
                pos = pos + 0.08;

                let id = $this.children().attr('id').replace('spa_p','');
                $this.attr('href', window.location.href+'/'+id);

                $this.mouseenter(function(){
                    $tooltip.addClass('active');
                    $title.html(obj.spas[id].title);
                    $img.attr('src',imgUrl+obj.spas[id].img);
                }).mousemove(function(e){
                    let top =  e.pageY - $(container).find('.about4-svg svg').position().top + 5;
                    let left = e.pageX - $tooltip.outerWidth() - 5;
                    $tooltip.css({
                        top: top,
                        left: left
                    });
                }).mouseleave(function(){
                    $tooltip.removeClass('active');
                });
            });

            ScrollTrigger.create({
                trigger: $svg,
                once: true,
                start: "top 45%",
                onEnter: function() {
                    tl.play();
                }
            });

        }
    },
    opened: function(container){

        let obj = this;
        let $svg = $(container).find('.zones-svg svg');
        if($svg.length > 0) {
            let $links = $svg.find('a');
            let $tooltip = $(container).find('.zones-svg--tooltip');
            let $title = $tooltip.find('.zones-svg--tooltipHeader');
            let $img = $tooltip.find('.zones-svg--tooltipImg img');
            let imgUrl = $svg.parent().data('url');

            let selected = $svg.parent().data('selected');
            let offset = $svg.position();

            let tl = gsap.timeline({paused: true});
            let pos = 0

            $links.each(function(){
                let $this = $(this);

                tl.to($this,{
                    delay: 0.7,
                    duration:0.8,
                    ease:'none',
                    onStart: function(){
                        $this.addClass('anim');
                    },
                    onComplete: function(){
                        $this.removeClass('anim');
                    }
                },pos);
                //pos = pos + 0.08;
                pos = pos + 0.08;


                let id = $this.children().attr('id').replace('spa_p','');
                $this.removeClass('js-barba');

                $this.mouseenter(function (e) {
                    $tooltip.addClass('active');
                    $title.html(obj.spas[id].title);
                    $img.attr('src',imgUrl+obj.spas[id].img);
                }).mousemove(function (e) {
                    let top =  e.pageY - $(container).find('.zones-svg svg').position().top;
                    let left = e.pageX;
                    $tooltip.css({
                        top: top,
                        left: left
                    })
                }).mouseleave(function (e) {
                    $tooltip.removeClass('active');
                }).on('click',function(e){
                    e.preventDefault();
                    scroller.scrollTo("[data-zone='"+id+"']", true);
                })
            });

            ScrollTrigger.create({
                trigger: $svg,
                once: true,
                start: "top 45%",
             //   markers: true,
                onEnter: function() {
                    console.log('derrp');
                    tl.play();
                }
            });

        }
    },
    open: function(container){
        $('.header').hide();
        $('.contacts').hide();
        $('body').addClass('spa-popup');
        spa.opened(container);
    },
    close: function(){
        $('body').removeClass('spa-popup');
        $('.header').show();
        $('.contacts').show();
    }
}
const gallery = {
    init: function(container = document ){
        let obj = this;
        let $galleries = $(container).find('section.galleries .galleries-cont');
        

        if($galleries.length > 0){
            let $list = $galleries.find('.galleries-nav');

            let $btns = $list.find('button');
            let $petal = $list.find('.galleries-nav--petal');
            let petalTo = gsap.quickTo($petal, "y",{duration: 0.3, ease: 'power2.out'});
            let $img = $galleries.find('.images .image');

            let to = 0;
            $petal.addClass('active');
            $btns.on('mouseenter', function(){
                let $this = $(this);
                if($this.hasClass('active')) return;
                let height = $this.height();
                let top = $this.position().top;
                let y = top + height * 0.7;
                petalTo(y);

                let key = $this.data('target') || 0;

                $btns.removeClass('active');
                $this.addClass('active');
                //$img.removeClass('active');
                let $img_active = $img.eq(key);
               // console.log(typeof($img_active[0].style.zIndex));

                if(to == 0){
                    $img.each(function(i, e){
                        e.style.zIndex = e.style.zIndex == '' ? 0 : e.style.zIndex - 1;
                        /* if(e.classList.contains('active')) {
                            e.classList.add('superduper');
                            setTimeout((k) => {
                                k.remove('superduper');
                            }, 100, e.classList);
                        } */
                    });
                    $img.find(".active").addClass("superduper");
                    $img.removeClass('active');
                    $img_active.addClass('active zoom').css('z-index', 20);
                    setTimeout((k) => {
                        k.removeClass('zoom');
                    }, 10, $img_active);
                    to = setTimeout(function(){
                        to = 0;
                    }, 1000);
                }else{
                    clearTimeout(to);
                    to = setTimeout(function(){
                        $img.each(function(i, e){
                            e.style.zIndex = e.style.zIndex == '' ? 0 : e.style.zIndex - 1;
                        });
                        $img.removeClass('active');
                        $img_active.addClass('active zoom').css('z-index', 20);
                        to = 0;
                        setTimeout((k) => {
                            k.removeClass('zoom');
                        }, 10, $img_active);
                    }, 100);
                }
            });

            $list.on('mouseleave', function(){
           /*     to = setTimeout(function(){
                    $petal.removeClass('active');
                }, 100);*/
            });

        }
    }
}
const { resolve } = require("path");

if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}

let crsf = csrf_init;
window.scroller = {};

$(async function(){

    window.scroller = ScrollSmoother.create({
        smooth: 1,
        effects: false,
        smoothTouch: 0.1,
        normalizeScroll: true,
        ignoreMobileResize: true
    });
    await tasks.yieldToMain();
    Fancybox.bind('[data-fancybox="newsletter"]', {
        autoFocus: false,
        closeButton: false,
        dragToClose: false,
        Hash: false,
        hideScrollbar: false,
        on: {
            done: (fancybox) => {
                // here `fancybox` refers to the current instance
            },
            destroy: () =>{
                $('.newsletter-cont, .newsletter-form').show();
                $('.newsletter-success').hide();
                let $form = $('#newsletter').find('form');
                $form
                    .find('.has-error')
                    .removeClass('has-error');
                $form[0]
                    .reset();
            }
        },
    });

    $(document).on('click','.btn-close', function(e){
        Fancybox.close();
    });

    let scrollY = 0;

    document.fonts.ready.then(function () {
        setTimeout(()=>{
            headerAnim.prep();
            loaderAway(()=>{});
            scroller.scrollTop(0);
            tasks.add([
                fp.init.bind(fp),
                forms.init.bind(forms),
                gdpr.init.bind(gdpr),
                introEdition.header.bind(introEdition),

                carousels.init.bind(carousels),
                list.init.bind(list),
                list.apartment.bind(list),

                apartments.init.bind(apartments),
                filter.init.bind(filter),
                gallery.init.bind(gallery),
                favorite.init.bind(favorite),
                headerAnim.init.bind(headerAnim),
                fadeUpAnim.init.bind(fadeUpAnim),
                zoomOutAnim.init.bind(zoomOutAnim),
                filterListAnim.init.bind(filterListAnim),
                ScrollTrigger.sort.bind(ScrollTrigger),
                ScrollTrigger.refresh.bind(ScrollTrigger),
            ]);
        },500);
    });

    barba.init({
        debug: true,
        timeout: 5000,
        cacheIgnore: ['/megstamiausi/'],
        prevent:({ el }) => !el.classList.contains('js-barba'),
        transitions: [{
            name: 'default-transition',
            once(data){
                return true;
            },
            leave(data) {
                return new Promise(resolve => {
                 ///   console.log('leave transition');
                    document.querySelector('#transition').classList.remove('rinktis');
                    setTimeout(function(){
                        loaderIn(resolve);
                    }, 0);
                });
            },
            enter(data) {
                return new Promise(resolve => {
                  //  console.log('enter transition');
                  //  console.log(scroller.scrollTop());
                    loaderAway(resolve, 0,data.next.container);
                });
            }
        },
            {
                name: 'nonen',
                from: {
                    namespace: ['floor-select','apart-select','viz-select']
                },
                to: {
                    namespace: ['floor-select','apart-select','viz-select']
                },
                once(data){
                    return true;
                },
                leave(data) {
                    return true;
                },
                enter(data) {
                    return true;
                }
            }
            ,{
            name: 'choose-transition',
            to: {
                namespace: ['viz-select']
            },
            once(data){
                return true;
            },
            leave(data) {
                return new Promise(resolve => {
                 ///   console.log('leave transition');
                    document.querySelector('#transition').classList.add('rinktis');
                    setTimeout(function(){
                        loaderIn(resolve);
                    }, 0);
                });
            },
            enter(data) {
                return new Promise(resolve => {
                    loaderAway(resolve);
                    //scroller.scrollTop(0);
                });
            }
        },{
            name: 'min-transition',
            from: {
                namespace: ['about','spa']
            },
            to: {
                namespace: ['spa','about']
            },
            once(data){
                return true;
            },
            leave(data) {
                return new Promise(resolve => {
                    gsap.to('#smooth-wrapper',{opacity: 0, onComplete: function(){
                        resolve();
                    }})
                });

              //  return true;
            },
            enter(data) {
              ///  return true;
            },
            after(data){
                if(data.next.namespace === 'spa') {
                    enterPos(data.next.container);
                }
                if(data.current.namespace === 'spa' && data.next.namespace === 'about'){
                    setTimeout(function(){
                        scroller.scrollTo($(data.next.container).find(".about4-zones").offset().top, false, 'center center');
                    },96);
                }
                return new Promise(resolve => {
                    gsap.to('#smooth-wrapper',{opacity: 1, delay:0.2,
                        onStart:function(){

                        },
                        onComplete: function(){
                        resolve();
                    }})
                });

            }
        }],
        views: [
            {
                namespace: 'home',
                beforeEnter(data) {

                },
                afterEnter(data) {

                },
                afterLeave(data){

                }
            },
            {
                namespace: 'spa',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    spa.open(data.next.container);
                    spa.init(data.next.container);
                },
                afterLeave(data){
                    spa.close(data.next.container);
                },
                after(data){

                }
            },
            {
                namespace: 'viz-select',
                beforeEnter(data) {

                },
                afterEnter(data) {

                },
                afterLeave(data){

                }
            },
            {
                namespace: 'floor-select',
                beforeEnter(data) {

                },
                afterEnter(data) {

                },
                afterLeave(data){

                }
            },
            {
                namespace: 'location',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    let $rins = $(data.next.container).find('.ring');
                    if($rins.length > 0) {
                        gsap.fromTo($rins, {
                            scale: 0.1,
                            //  opacity: 0,
                            opacity: 0.3,
                            transformOrigin: "50% 50%",
                        }, {
                            scale: 1.4,
                            opacity: 0,
                            transformOrigin: "50% 50%",
                            duration: 3,
                            ease: 'none',
                            stagger: {
                                each: 0.5,
                                repeat: -1
                            }
                        });
                    }
                },
                afterLeave(data){

                }
            },
            {
                namespace: 'about',
                once(data){
                    console.log('once');
                },
                beforeEnter(data) {

                },
                afterEnter(data) {
                  //  list.init(data.next.container);
                    spa.init(data.next.container);
                },
                afterLeave(data){

                }
            },{
                namespace: 'gdpr',
                beforeEnter(data) {
                    headers.hide();
                    let $gdpr = $('#CookieDeclaration');
                    console.log($gdpr);
                    $gdpr.attr('src' , $gdpr.attr('src')+"?22");
                   /* var arr = data.next.container.getElementsByTagName('script')
                    for (var n = 0; n < arr.length; n++)
                        eval(arr[n].innerHTML)*/

                    let gdprTxt = $('#hiddenGDPR').html();
                    $(data.next.container).find('#gdprHolder').html(gdprTxt);

                },
                afterLeave(data){
                    headers.show();
                }
            }
        ]
    });


    barba.hooks.enter((data) => {
        headerAnim.prep(),

        tasks.add([
            //headerAnim.prep.bind(headerAnim),
            //scroller.effects.bind(scroller, data.next.container.querySelector('[data-speed]')),
            galleries.init.bind(galleries, data.next.container),
            fp.init.bind(fp, data.next.container),
            list.apartment.bind(list, data.next.container),

            carousels.init.bind(carousels, data.next.container),
            list.init.bind(list, data.next.container),
            apartments.init.bind(apartments, data.next.container),
            filter.init.bind(filter, data.next.container),
            gallery.init.bind(gallery, data.next.container),
            carousels.spa.bind(carousels, data.next.container),


            headerAnim.init.bind(headerAnim),
            fadeUpAnim.init.bind(fadeUpAnim),
            zoomOutAnim.init.bind(zoomOutAnim),
            filterListAnim.init.bind(filterListAnim),
            ScrollTrigger.sort.bind(ScrollTrigger),
            ScrollTrigger.refresh.bind(ScrollTrigger),
            () => {
                document.querySelectorAll('[data-spin]').forEach((el)=>{
                    gsap.fromTo(el, {rotate: 0}, {
                        rotate: (Number(el.dataset.spin) * 360) || 0,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: el,
                            scrub: true,
                            start: 'top bottom',
                            end: 'bottom top',
                            //markers: true
                        }
                    });
                });

                if(data.next.namespace == 'location' || data.next.namespace == 'about'){
                    data.next.container.querySelectorAll('video[autoplay]').forEach(
                        video => {
                            video.play();
                        }
                    );
                }
            }
        ]);

        

        

        

      //  forms.init(data.next.container);

     //   introEdition.init(data.next.container);

        

        
    });

    carousels.spa();

    barba.hooks.once((data) => {
        console.time('once hook');
        let header = $(data.next.container).data('header');
        $('body')
            .removeClass('light dark')
            .addClass(header);

        //headers.position();
        scroller.effects(data.next.container.querySelectorAll('[data-speed]'));
        document.querySelectorAll('[data-spin]').forEach((el)=>{
            gsap.fromTo(el, {rotate: 0}, {
                rotate: (Number(el.dataset.spin) * 360) || 0,
                ease: 'none',
                scrollTrigger: {
                    trigger: el,
                    scrub: true,
                    start: 'top bottom',
                    end: 'bottom top',
                    //markers: true
                }
            });
        });
        console.timeEnd('once hook');
    });

    barba.hooks.beforeLeave((data)=>{
        console.time('before leave hook');
        headers.menu.removeClass('transi');


        $('body')
            .removeClass('light')
            .removeClass('dark');
        document.body.classList.add('trans-anim');
        headers.menu.addClass('page-top')
        if(headers.width <= 860){
            setTimeout(headers.toggleMenu, 500, "hide");
        }
        console.timeEnd('before leave hook');
    });

    barba.hooks.beforeEnter((data)=>{
        console.time('before enter hook');
        // loop through window.timelines_triggers array and kill all timelines, leave the array empty afterwards.
        while (window.timelines_triggers.length > 0) {
            let tl = window.timelines_triggers.pop();
            if (tl.kill) tl.kill();
        }
        ScrollTrigger.getAll().forEach(t => t.kill());
        data.current.container.remove();
        $(".now").removeClass("now");
        scroller.scrollTop(0);
        let header = $(data.next.container).data('header');
        $('body').addClass(header);
        
        //headers.position();
        
        headers.current($(data.next.container).data('class'));
        setTimeout(()=>{
            scroller.effects(data.next.container.querySelector('[data-speed]'));
            ScrollTrigger.sort();
            ScrollTrigger.refresh();
        }, 1)
        //scroller.effects(data.next.container.querySelector('[data-speed]'));
        console.timeEnd('before enter hook');
    });

    barba.hooks.afterEnter((data)=>{
        console.time('after enter hook');
        document.body.classList.remove('trans-anim');
       // headers.toggleColor(data.next.container);
        headers.menu.addClass('transi');
        setTimeout(headers.position, 500);
        console.timeEnd('after enter hook');
    });

    $(document).on('click','.contacts-popup', function(e){
        e.preventDefault();
        scroller.paused(true);
        $(document).find('.contacts-form').addClass('active');
    })

    $(document).on('click', '.contacts-form--close button', function(){
        $(document)
            .find('.contacts-form')
            .removeClass('active');

        forms.reset();
        scroller.paused(false);
    });

    headers.init();

    Fancybox.bind('[data-fancybox="iframe"]', {
        Hash: false,
        closeBtn: true,
        template: {
             closeButton : `
             <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55">
                <g fill="none">
                    <path stroke="#D2D3D3" stroke-linecap="round" stroke-linejoin="round" d="m20.45 20.45 14.1 14.1m-14.1-.01 14.1-14.09" class="x"/>
                    <path fill="#d2d3d3" d="M27.5 1A26.33 26.33 0 0 0 8.76 8.76 26.41 26.41 0 0 0 1 27.5a26.33 26.33 0 0 0 7.76 18.74A26.41 26.41 0 0 0 27.5 54a26.33 26.33 0 0 0 18.74-7.76A26.41 26.41 0 0 0 54 27.5a26.33 26.33 0 0 0-7.76-18.74A26.41 26.41 0 0 0 27.5 1m0-1a27.5 27.5 0 1 1 0 55 27.5 27.5 0 0 1 0-55Z"/>
                </g>
            </svg>`
        },
        on: {
            initLayout: (fancybox) => {}
        }
    })
    Fancybox.bind('[data-fancybox="zones"]', {
        Hash: false,

        on: {
            initLayout: (fancybox)=> {
                $(fancybox.$container).addClass('zones-fancybox');
            },
            done: (fancybox, el) => {
                scroller.paused(true);
                const wrap = fancybox.$container.querySelector(
                    ".fancybox__slide.is-selected .scrollMe"
                );

                const content = wrap.querySelector(".sContent");
                const anim = content.querySelector(".sAnim");

                let $old = $(wrap).find('.spacer');
                if($old.length > 0){
                    $old.remove();
                }

                const spacer = document.createElement("div");

                spacer.classList.add("spacer");
                spacer.style.width = `${content.offsetWidth}px`;
                spacer.style.height = `${wrap.scrollHeight}px`;
                wrap.appendChild(spacer);
                content.style.position = "absolute";

                gsap.fromTo(
                    anim,
                    { y: 0 },
                    {
                        y: () => {
                            let wh = wrap.getBoundingClientRect();
                            let ch = content.getBoundingClientRect();
                            return -(ch.height - wh.height);
                            //return 0;
                        },
                        duration: 1,
                        ease: "none",
                        scrollTrigger: {
                            trigger: spacer,
                            scroller: wrap,
                            start: "top top",
                            end: "bottom bottom",
                            scrub: 1,
                            pin: content,
                            pinSpacing: false,
                            pinType: "transform",
                        }
                    }
                );
            },
            shouldClose: (fancybox) => {
                scroller.paused(false);
            },
            destroy: (fancybox) =>{

            },
            close: (fancybox) => {

            }
        }
    });

    $(document).on('click', '.zones-close, .zones-back', function(){
        Fancybox.close();
    });

    galleries.init();

    $(document).on('click', '.scroll-to', function(e){
        e.preventDefault();
        let $this = $(this);
        let target = $this.data('target');
        let offset = 0;
        if($(document).width() < 1024){
            offset = $(document).find('.header-mobile').outerHeight();
        }
        scroller.scrollTo($(document).find(target).offset().top - offset, true);
    });

    $(document).on('click','.sold', function(e){
        e.preventDefault();
    })
})

function loaderIn(resolve = {}){
    scroller.paused(true);
    gsap.set(['#tClip1 > path', '#tClip2 > path'], {attr: {d: "M0-100V-15S13.96-1.26 49.79-1.26 100-15 100-15V-100H0Z"}});
    gsap.to(['#tClip1 > path', '#tClip2 > path'], {
        keyframes: {
            "0%": {attr: {d: "M0-100V-15S13.96-1.26 49.79-1.26 100-15 100-15V-100H0Z"}, ease: 'power3.inOut'},
            "100%": {attr: {d: "M0-100V107.64S13.96 100.19 49.79 100.19 100 107.64 100 107.64V-100H0Z"}}
        },
        duration: 0.8,
        stagger: 0.03,
        ease: 'power2.inOut',
        onComplete: () => {
            console.log('loaderIn end')
            resolve();
        }
    });
    gsap.from('#transition .nativo-deco', {autoAlpha: 0, duration: 1.2, y:"50vh", ease: 'power4.out'});
    gsap.set('#transition', {autoAlpha: 1});
}

function loaderAway(resolve = {}, delay = 0, container = document){
    ScrollTrigger.refresh();
    gsap.fromTo('#transition', {
        autoAlpha: 1,
    }, {
        autoAlpha: 0,
        delay: delay,
        duration: 0.8,
        onComplete: () => {
            scroller.paused(false);
            resolve();
        }
    });
}

function enterPos(container = document){
    ScrollTrigger.refresh();
    // insta nori
    let $svg = $(container).find('.zones-svg svg');
    let selected = $svg.parent().data('selected');
    if(selected !== 'undefined' && $svg.length > 0 && $(document).width() > 641) {
        setTimeout(function(){
            let selected_zone = $(container).find("[data-zone='" + selected + "']");
            if(selected_zone.length) scroller.scrollTo(selected_zone.offset().top, false);
        },90);
    }
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}